<script setup>
import StaticMetric from '../../../../pha/modules/dashboard/components/StaticMetric';

import { ref, onMounted, computed, defineProps, watchEffect, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useDashboardStore } from '../store/dashboard';

const props = defineProps({
    id: {
        type: Number,
    },
});

// Store states
const dashboardStore = useDashboardStore();
const { dashboards } = storeToRefs(dashboardStore);

// Component states
const dashboard = ref(null);
const loading = ref(false);

// Computed properties
const dashboardMetrics = computed(() => {
    return dashboard.value?.details;
});

onMounted(() => {
    watchEffect(() => {
        loadReports();
    });
});

onUnmounted(() => {
    dashboardStore.initDashboardDetails();
});

const loadReports = async () => {
    loading.value = true;
    // If there is props id then load that dashboard
    if (props.id) {
        const dashboardId = parseInt(props.id);
        // Again, there is no dashboard details API so we need to load all dashboard and extract by id from there
        await dashboardStore.getDSDashboards({ paginate: false });
        // now check there
        dashboard.value = dashboards.value?.find((dashboard) => dashboard.id === dashboardId);
    }
    // load default dashboard
    else {
        //
    }

    loading.value = false;
};
</script>

<template>
    <div class="card">
        <div v-if="loading">
            <div class="flex justify-content-between">
                <Skeleton class="m-2" height="20rem" borderRadius="16px" />
                <Skeleton class="m-2" height="20rem" borderRadius="16px" />
            </div>
            <ScaleLoader />

            <div class="flex justify-content-between">
                <Skeleton class="m-2" height="20rem" borderRadius="16px" />
                <Skeleton class="m-2" height="20rem" borderRadius="16px" />
            </div>
        </div>
        <div v-else-if="dashboardMetrics?.length" class="grid p-fluid">
            <div class="col-12 lg:col-6" v-for="metric in dashboardMetrics" :key="metric.id">
                <StaticMetric :metric="metric" />
            </div>
        </div>
        <div v-else class="col-12">
            <div class="px-4 py-8 md:px-6 lg:px-8 text-center">
                <div class="mb-3 font-bold text-2xl">
                    <span class="text-900"> No Metrics Data available in the dashboard </span>
                </div>
            </div>
        </div>
    </div>
</template>
